import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { cleanOptions, setFilterSelection } from "../../../redux/slices/indicatorDisplay/SearchAndFilter/filterAndSearchSlice";
import { ISelectedItem } from "../../../components/Inputs/Selects/MultiSelectCheck";
import { toggleSelected } from "../utils/helpers";
import { EMPTY_DRAFT, FilterDraft, isOnlyStructural, isSameDraft, resolveDraft } from "../utils/filterDraft";

type DraftKey = keyof FilterDraft;

// Borrador del filtro: lo que se está eligiendo en el modal, todavía sin aplicar
export const useFilterDraft = () => {
    const dispatch = useAppDispatch();
    const { rights } = useAppSelector((state) => state.indicator_display_filter);
    const [draft, setDraft] = useState<FilterDraft>(EMPTY_DRAFT);

    const updateDraft = (newDraft: FilterDraft) => {
        const resolved = resolveDraft(newDraft, rights);
        setDraft(resolved);
        dispatch(setFilterSelection({ rights: resolved.rights, selection: resolved }));
    };

    // Vacía todo el borrador, derechos incluidos
    const resetDraft = () => {
        dispatch(cleanOptions("dimension"));
        setDraft(EMPTY_DRAFT);
    };

    // "Limpiar" del modal
    const cleanDraft = () => updateDraft({ ...EMPTY_DRAFT });

    // "Seleccionar todos"
    const setDraftField = <K extends DraftKey>(key: K) => (values: FilterDraft[K]) => {
        const newDraft: FilterDraft = { ...draft, [key]: values };
        if (key === "types" && isOnlyStructural(newDraft.types)) newDraft.ods = [];
        updateDraft(newDraft);
    };

    // Click en un item: lo agrega o lo quita del campo del borrador
    const toggleDraftField = <K extends DraftKey>(key: K) => (value: FilterDraft[K][number]) => {
        if (!value) return;
        const current: (string | ISelectedItem)[] = draft[key];
        setDraftField(key)(toggleSelected(current, value) as FilterDraft[K]);
    };

    // Si hay algo elegido además de los derechos
    const hasDraftFilters = !isSameDraft(draft, { ...EMPTY_DRAFT });

    return { draft, updateDraft, resetDraft, cleanDraft, setDraftField, toggleDraftField, hasDraftFilters };
};
